import axios from 'axios'
import { API_ENDPOINT } from '../config'
import Qs from 'qs'

class Api {
  constructor() {
    this.axios = axios.create({
      headers: {
        'Content-Type': 'application/json',
      },
      paramsSerializer: (params) =>
        Qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  request = async (endpoint, params) => {
    try {
      return await this.axios(`${API_ENDPOINT}${endpoint}`, params)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  get = async (endpoint, params, headers, responseType) => {
    return this.request(endpoint, {
      method: 'get',
      params,
      headers,
      responseType: responseType ? responseType : 'json',
    })
  }

  post = (endpoint, data, headers) => {
    return this.request(endpoint, {
      method: 'post',
      data,
      headers,
    })
  }

  delete = (endpoint, data, headers) => {
    return this.request(endpoint, {
      method: 'delete',
      data,
      headers,
    })
  }

  put = (endpoint, data, headers) => {
    return this.request(endpoint, {
      method: 'put',
      data,
      headers,
    })
  }

  patch = (endpoint, data, headers) => {
    return this.request(endpoint, {
      method: 'patch',
      data,
      headers,
    })
  }
}

export default new Api()
